import React from 'react'

import Svg, { Defs, G, Path, Rect } from 'react-native-svg'

const CurrencyIcon = ({ size = 28, color = '#596379', ...props }) => {
  return (
    <Svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
    >
      <G clipPath="url(#clip0_6479_31550)">
        <Path
          d="M23.9517 11.2583C24.2317 11.2583 24.4534 11.48 24.4534 11.76V20.9067C24.4534 21.1867 24.2317 21.4083 23.9517 21.4083H6.46337C6.18337 21.4083 5.9617 21.1867 5.9617 20.9067V11.76C5.9617 11.48 6.18337 11.2583 6.46337 11.2583H23.94M23.94 9.625H6.46337C5.28504 9.625 4.32837 10.5817 4.32837 11.76V20.9067C4.32837 22.085 5.28504 23.0417 6.46337 23.0417H23.94C25.1184 23.0417 26.075 22.085 26.075 20.9067V11.76C26.075 10.5817 25.1184 9.625 23.94 9.625Z"
          fill={color}
        />
        <Path
          d="M20.8483 12.7517C20.8483 12.6583 20.86 12.565 20.8833 12.4717H9.77666C9.79999 12.565 9.81166 12.6583 9.81166 12.7517C9.81166 13.65 8.91332 14.385 7.81666 14.385C7.73499 14.385 7.65332 14.3733 7.57166 14.3617V18.2933C7.65332 18.2933 7.73499 18.27 7.81666 18.27C8.92499 18.27 9.81166 19.005 9.81166 19.9033C9.81166 19.9967 9.79999 20.09 9.77666 20.1833H20.8833C20.86 20.09 20.8483 19.9967 20.8483 19.9033C20.8483 19.005 21.7467 18.27 22.8433 18.27V14.3733C21.735 14.3733 20.8483 13.6383 20.8483 12.74V12.7517ZM10.9433 17.0567C10.5467 17.0567 10.22 16.73 10.22 16.3333C10.22 15.9367 10.5467 15.61 10.9433 15.61C11.34 15.61 11.6667 15.9367 11.6667 16.3333C11.6667 16.73 11.34 17.0567 10.9433 17.0567ZM15.2017 18.2C14.175 18.2 13.335 17.36 13.335 16.3333C13.335 15.3067 14.175 14.4667 15.2017 14.4667C16.2283 14.4667 17.0683 15.3067 17.0683 16.3333C17.0683 17.36 16.2283 18.2 15.2017 18.2ZM19.425 17.1267C19.0283 17.1267 18.7017 16.8 18.7017 16.4033C18.7017 16.0067 19.0283 15.68 19.425 15.68C19.8217 15.68 20.1483 16.0067 20.1483 16.4033C20.1483 16.8 19.8217 17.1267 19.425 17.1267Z"
          fill={color}
        />
        <Path
          d="M4.095 17.9083H3.71C3.43 17.9083 3.20834 17.6867 3.20834 17.4067V8.26C3.20834 7.98 3.43 7.75833 3.71 7.75833H21.1867C21.4667 7.75833 21.6883 7.98 21.6883 8.26V9.33333H23.3217V8.26C23.3217 7.08167 22.365 6.125 21.1867 6.125H3.72167C2.54334 6.125 1.58667 7.08167 1.58667 8.26V17.4067C1.58667 18.585 2.54334 19.5417 3.72167 19.5417H4.10667V17.9083H4.095Z"
          fill={color}
        />
      </G>
      <Defs>
        <clipPath id="clip0_6479_31550">
          <Rect width={`${size}`} height={`${size}`} fill="white" />
        </clipPath>
      </Defs>
    </Svg>
  )
}

export default CurrencyIcon
